import React, { useContext, useEffect, useState, useRef } from 'react';
import StringField from 'Common/Components/StringField';
import Select from './Select';
import { useDispatch, useSelector } from 'react-redux';
import { Wrapper, Container, Title, Error, InputContainer } from './styled';
import { get, isEmpty } from 'lodash';
import { CVSS_TYPES, CVSS_TYPES_LABELS, getCVSSType, isWrong, parseCVSSEntry, DEFAULT_CVSS_TYPE, hasCVSSValue } from './constants';
import { setFiedsError } from 'Screens/Contextualization/ManageEditCreate/actions/Actions';
import { ThemeContext } from 'Context';
import { updateVulnTemplate } from 'Screens/Contextualization/KnowledgeBase/actions/Actions';
import { selectVulnTemplateDetail } from 'store/KnowledgeBase/selectors';

const getCVSSValue = (vulnTemplate, type) => {
  const vectorString = get(vulnTemplate, `${type}.vector_string`, '');
  if (!isEmpty(vectorString)) return vectorString;

  const baseScore = get(vulnTemplate, `${type}.base_score`, '');
  return hasCVSSValue(baseScore) ? String(baseScore) : '';
};

const CVSS = () => {
  const dispatch = useDispatch();
  const { themeStyles } = useContext(ThemeContext);
  const isFirstRun = useRef(true);
  const vulnTemplate = useSelector(selectVulnTemplateDetail);
  const id = get(vulnTemplate, '_id', 0);

  const [type, setType] = useState(getCVSSType(vulnTemplate) || DEFAULT_CVSS_TYPE);
  const [vector, setVector] = useState(getCVSSValue(vulnTemplate, type));
  const [error, setError] = useState(isWrong(vector, type));

  const onChangeInput = (value) => {
    const parsedEntry = parseCVSSEntry(value, type);

    if (parsedEntry) dispatch(updateVulnTemplate(id, { [type]: parsedEntry }));
    if (isEmpty(value)) dispatch(updateVulnTemplate(id, { [type]: { vector_string: '', base_score: '' } }));
    setError(isWrong(value, type));
  };

  const onChangeSelect = (value) => {
    setVector('');
    setError(false);
    setType(CVSS_TYPES[value]);
  };

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }

    const types = Object.values(CVSS_TYPES) || [];
    types.forEach((e) => {
      if (e !== type) {
        const value = getCVSSValue(vulnTemplate, e);
        if (!isEmpty(value)) {
          dispatch(updateVulnTemplate(id, { [e]: { vector_string: '', base_score: '' } }));
          setVector('');
          dispatch(setFiedsError(false));
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  useEffect(() => {
    const newType = getCVSSType(vulnTemplate) || DEFAULT_CVSS_TYPE;
    const newVector = getCVSSValue(vulnTemplate, newType);

    setType(newType);
    setVector(newVector);
    setError(isWrong(newVector, newType));
  }, [vulnTemplate]);

  return (
      <Wrapper>
        <Title>CVSS Severity Score</Title>
        <Container>
            <Select theme={ themeStyles } updateValue={ (value) => onChangeSelect(value) } defaultValue={ CVSS_TYPES_LABELS[type] || '' } />
            <InputContainer>
              <StringField
                key={ type }
                error={ error }
                className="custom-background"
                width="100%"
                height="38px"
                name="cvss"
                defaultValue={ vector }
                onChange={ (value) => onChangeInput(value) }
              />
            </InputContainer>
        </Container>
        {error && <Error>Invalid format</Error>}
      </Wrapper>
  );
};

export default CVSS;
